import JsonApi from 'devour-client';
import { ServiceBase } from './ServiceBase';
import { PaymentMethodPayload } from '../payloads/PaymentMethodPayload';

export class PaymentMethodService extends ServiceBase<PaymentMethodPayload> {
  constructor(jsonApi: JsonApi) {
    const schema = PaymentMethodPayload.getSchema();

    super(jsonApi, 'card_payment_method', schema, PaymentMethodPayload);
  }
}
